const copyFolderLink = (folderId, meetingId) => {
  const { origin } = window.location;

  const url = meetingId
    ? `${origin}/my-videos/${meetingId}`
    : `${origin}/my-library/${folderId}`;

  navigator.clipboard.writeText(url);
};

export default copyFolderLink;
